export enum QuickOrderEntryInputTypeEnum {
  INPUT_TYPE_PRODUCT_NUMBER = 'product-number',
  INPUT_TYPE_CASES = 'quantity-cases',
  INPUT_TYPE_EACHES = 'quantity-eaches',
}
export enum QuickOrderEntryToggleButtonEnum {
  TOGGLE_BTN_PRODUCT_NUMBER = 'productNum',
  TOGGLE_BTN_CUST_NUMBER = 'productCustNum',
}
